import { render, staticRenderFns } from "./MouseCoordsControl.vue?vue&type=template&id=02b286e9&"
import script from "./MouseCoordsControl.vue?vue&type=script&lang=js&"
export * from "./MouseCoordsControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports